(() => {
  if (window.__adawatCardSwatchesBound) return;
  window.__adawatCardSwatchesBound = true;

  const applySwatch = (swatch) => {
    const card = swatch.closest('.adawat-product-card, .adawat-mega__product');
    if (!card) return;

    const src = swatch.getAttribute('data-image-src');
    const srcset = swatch.getAttribute('data-image-srcset');
    const variantUrl = swatch.getAttribute('data-variant-url');
    const img = card.querySelector('.adawat-product-card__image--primary, .adawat-mega__product-image');

    if (src && img) {
      img.removeAttribute('srcset');
      if (srcset) img.setAttribute('srcset', srcset);
      img.src = src;
      card.classList.add('adawat-product-card--swatch-active');
    }

    if (variantUrl) {
      card.querySelectorAll('.adawat-product-card__media-link, .adawat-product-card__title a, a.adawat-product-card__add-btn, .adawat-mega__product-link').forEach((link) => {
        link.setAttribute('href', variantUrl);
      });
      const compare = card.querySelector('[data-compare-toggle]');
      if (compare && src) compare.setAttribute('data-product-image', src);
    }

    const group = swatch.closest('.adawat-product-card__swatches');
    group?.querySelectorAll('.adawat-product-card__swatch').forEach((btn) => {
      const on = btn === swatch;
      btn.classList.toggle('is-selected', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  };

  document.addEventListener(
    'click',
    (event) => {
      const swatch = event.target.closest('.adawat-product-card__swatch');
      if (!swatch) return;
      event.preventDefault();
      event.stopPropagation();
      applySwatch(swatch);
    },
    true
  );
})();
